// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("./image.res.js");

function clampPage(currentPage, totalPages) {
  if (currentPage < 1) {
    return 1;
  } else if (currentPage > totalPages) {
    return totalPages;
  } else {
    return currentPage;
  }
}

var navButtonClass = "h-9 w-9 flex items-center justify-center rounded-lg border border-gray-200 bg-white text-aurometalsaurus hover:bg-gray-50 hover:border-gray-300 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white transition-colors focus:outline-none focus:ring-2 focus:ring-pigmentblue focus:ring-offset-1";

var pageButtonClass = "h-9 min-w-9 px-2.5 flex items-center justify-center rounded-lg text-sm font-medium text-aurometalsaurus hover:bg-white hover:shadow-sm focus:outline-none transition-colors";

var activePageButtonClass = "h-9 min-w-9 px-2.5 flex items-center justify-center rounded-lg text-sm font-semibold bg-pigmentblue text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-pigmentblue focus:ring-offset-1";

var compactShellClass = "inline-flex items-center gap-1 p-1 rounded-lg border border-gray-200 bg-gray-50";

function Pagination$Controls(props) {
  var handlePageChange = props.handlePageChange;
  var __className = props.className;
  var __compact = props.compact;
  var __siblingCount = props.siblingCount;
  var __currentPage = props.currentPage;
  var total = props.total;
  var currentPage = __currentPage !== undefined ? __currentPage : 1;
  var siblingCount = __siblingCount !== undefined ? __siblingCount : 2;
  var compact = __compact !== undefined ? __compact : false;
  var className = __className !== undefined ? __className : "";
  var totalPages = total <= 0 ? 1 : total;
  var currentPage$1 = clampPage(currentPage, totalPages);
  var leftSiblingCount;
  if (currentPage$1 === 1) {
    leftSiblingCount = 0;
  } else if ((currentPage$1 - 1 | 0) < siblingCount) {
    leftSiblingCount = currentPage$1 - 1 | 0;
  } else if ((currentPage$1 - 1 | 0) === siblingCount || (totalPages - currentPage$1 | 0) >= siblingCount) {
    leftSiblingCount = siblingCount;
  } else {
    var addToLeft = siblingCount - (totalPages - currentPage$1 | 0) | 0;
    leftSiblingCount = (currentPage$1 - 1 | 0) > (siblingCount + addToLeft | 0) ? siblingCount + addToLeft | 0 : currentPage$1 - 1 | 0;
  }
  var rightSiblingCount;
  if (totalPages === currentPage$1) {
    rightSiblingCount = 0;
  } else if ((totalPages - currentPage$1 | 0) < siblingCount) {
    rightSiblingCount = totalPages - currentPage$1 | 0;
  } else if ((totalPages - currentPage$1 | 0) === siblingCount || (currentPage$1 - 1 | 0) >= siblingCount) {
    rightSiblingCount = siblingCount;
  } else {
    var addToRight = siblingCount - (currentPage$1 - 1 | 0) | 0;
    rightSiblingCount = (totalPages - currentPage$1 | 0) > (siblingCount + addToRight | 0) ? siblingCount + addToRight | 0 : totalPages - currentPage$1 | 0;
  }
  var leftSiblings = function (currentPage, leftSiblingCount) {
    if (leftSiblingCount !== 0) {
      if (leftSiblingCount !== 1) {
        return List.append(leftSiblings(currentPage - 1 | 0, leftSiblingCount - 1 | 0), {
                    hd: {
                      TAG: "Page",
                      _0: currentPage - 1 | 0
                    },
                    tl: /* [] */0
                  });
      } else {
        return {
                hd: {
                  TAG: "Page",
                  _0: currentPage - 1 | 0
                },
                tl: /* [] */0
              };
      }
    } else {
      return /* [] */0;
    }
  };
  var rightSiblings = function (currentPage, rightSiblingCount) {
    if (rightSiblingCount !== 0) {
      if (rightSiblingCount !== 1) {
        return List.append({
                    hd: {
                      TAG: "Page",
                      _0: currentPage + 1 | 0
                    },
                    tl: /* [] */0
                  }, rightSiblings(currentPage + 1 | 0, rightSiblingCount - 1 | 0));
      } else {
        return {
                hd: {
                  TAG: "Page",
                  _0: currentPage + 1 | 0
                },
                tl: /* [] */0
              };
      }
    } else {
      return /* [] */0;
    }
  };
  var pageButtons = function (param) {
    var xs = leftSiblings(currentPage$1, leftSiblingCount);
    var firstPart;
    var exit = 0;
    if (xs) {
      var match = xs.hd;
      if (typeof match !== "object" || match.TAG !== "Page") {
        exit = 1;
      } else {
        var match$1 = match._0;
        if (match$1 !== 1) {
          if (match$1 !== 2) {
            exit = 1;
          } else {
            firstPart = List.append({
                  hd: {
                    TAG: "Page",
                    _0: 1
                  },
                  tl: /* [] */0
                }, {
                  hd: {
                    TAG: "Page",
                    _0: 2
                  },
                  tl: xs.tl
                });
          }
        } else {
          firstPart = {
            hd: {
              TAG: "Page",
              _0: 1
            },
            tl: xs.tl
          };
        }
      }
    } else {
      firstPart = /* [] */0;
    }
    if (exit === 1) {
      firstPart = List.append({
            hd: {
              TAG: "Page",
              _0: 1
            },
            tl: {
              hd: {
                TAG: "Separator",
                _0: "..."
              },
              tl: /* [] */0
            }
          }, xs);
    }
    var xs$1 = List.rev(rightSiblings(currentPage$1, rightSiblingCount));
    var lastPart;
    var exit$1 = 0;
    if (xs$1) {
      var x = xs$1.hd;
      if (typeof x !== "object" || x.TAG !== "Page") {
        exit$1 = 1;
      } else {
        var rest = xs$1.tl;
        var x$1 = x._0;
        if (x$1 === totalPages) {
          lastPart = List.rev({
                hd: {
                  TAG: "Page",
                  _0: x$1
                },
                tl: rest
              });
        } else if (x$1 === (totalPages - 1 | 0)) {
          lastPart = List.append(List.rev({
                    hd: {
                      TAG: "Page",
                      _0: x$1
                    },
                    tl: rest
                  }), {
                hd: {
                  TAG: "Page",
                  _0: totalPages
                },
                tl: /* [] */0
              });
        } else {
          exit$1 = 1;
        }
      }
    } else {
      lastPart = /* [] */0;
    }
    if (exit$1 === 1) {
      lastPart = List.append(List.rev(xs$1), {
            hd: {
              TAG: "Separator",
              _0: "..."
            },
            tl: {
              hd: {
                TAG: "Page",
                _0: totalPages
              },
              tl: /* [] */0
            }
          });
    }
    return List.append({
                hd: "PreviousPage",
                tl: /* [] */0
              }, List.append(firstPart, List.append({
                        hd: {
                          TAG: "Page",
                          _0: currentPage$1
                        },
                        tl: /* [] */0
                      }, List.append(lastPart, {
                            hd: "NextPage",
                            tl: /* [] */0
                          }))));
  };
  if (compact) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("button", {
                        children: JsxRuntime.jsx("img", {
                              className: "h-3 w-3",
                              alt: "",
                              src: Image$ReactHooksTemplate.arrowLeft
                            }),
                        "aria-label": "Previous page",
                        className: navButtonClass,
                        disabled: currentPage$1 <= 1,
                        type: "button",
                        onClick: (function (param) {
                            Curry._1(handlePageChange, currentPage$1 - 1 | 0);
                          })
                      }),
                  JsxRuntime.jsx("span", {
                        children: String(currentPage$1),
                        className: "h-9 min-w-9 px-3 flex items-center justify-center rounded-lg text-sm font-semibold bg-pigmentblue text-white"
                      }),
                  JsxRuntime.jsx("button", {
                        children: JsxRuntime.jsx("img", {
                              className: "h-3 w-3",
                              alt: "",
                              src: Image$ReactHooksTemplate.arrowRight
                            }),
                        "aria-label": "Next page",
                        className: navButtonClass,
                        disabled: currentPage$1 >= totalPages,
                        type: "button",
                        onClick: (function (param) {
                            Curry._1(handlePageChange, currentPage$1 + 1 | 0);
                          })
                      })
                ],
                className: compactShellClass + " " + className
              });
  } else {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("nav", {
                      children: JsxRuntime.jsx("ul", {
                            children: $$Array.of_list(Belt_List.map(pageButtons(), (function (pageButton) {
                                        if (typeof pageButton !== "object") {
                                          if (pageButton === "PreviousPage") {
                                            return JsxRuntime.jsx("li", {
                                                        children: JsxRuntime.jsx("button", {
                                                              children: JsxRuntime.jsx("img", {
                                                                    className: "h-3 w-3",
                                                                    alt: "",
                                                                    src: Image$ReactHooksTemplate.arrowLeft
                                                                  }),
                                                              "aria-label": "Previous page",
                                                              className: navButtonClass,
                                                              disabled: currentPage$1 === 1,
                                                              type: "button",
                                                              onClick: (function (param) {
                                                                  Curry._1(handlePageChange, currentPage$1 - 1 | 0);
                                                                })
                                                            })
                                                      }, "prev");
                                          } else {
                                            return JsxRuntime.jsx("li", {
                                                        children: JsxRuntime.jsx("button", {
                                                              children: JsxRuntime.jsx("img", {
                                                                    className: "h-3 w-3",
                                                                    alt: "",
                                                                    src: Image$ReactHooksTemplate.arrowRight
                                                                  }),
                                                              "aria-label": "Next page",
                                                              className: navButtonClass,
                                                              disabled: currentPage$1 === totalPages,
                                                              type: "button",
                                                              onClick: (function (param) {
                                                                  Curry._1(handlePageChange, currentPage$1 + 1 | 0);
                                                                })
                                                            })
                                                      }, "next");
                                          }
                                        }
                                        if (pageButton.TAG === "Page") {
                                          var x = pageButton._0;
                                          return JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("button", {
                                                            children: String(x),
                                                            className: x === currentPage$1 ? activePageButtonClass : pageButtonClass,
                                                            type: "button",
                                                            onClick: (function (param) {
                                                                Curry._1(handlePageChange, x);
                                                              })
                                                          })
                                                    }, String(x));
                                        }
                                        var x$1 = pageButton._0;
                                        return JsxRuntime.jsx("li", {
                                                    children: JsxRuntime.jsx("span", {
                                                          children: x$1,
                                                          className: "h-9 w-9 flex items-center justify-center text-xs text-aurometalsaurus"
                                                        })
                                                  }, "sep-" + x$1);
                                      }))),
                            className: "inline-flex items-center gap-1 p-1 rounded-lg border border-gray-200 bg-gray-50"
                          }),
                      "aria-label": "Pagination"
                    }),
                className: className
              });
  }
}

var Controls = {
  make: Pagination$Controls
};

function Pagination(props) {
  var __className = props.className;
  var __compact = props.compact;
  var __siblingCount = props.siblingCount;
  var __currentPage = props.currentPage;
  var currentPage = __currentPage !== undefined ? __currentPage : 1;
  var siblingCount = __siblingCount !== undefined ? __siblingCount : 2;
  var compact = __compact !== undefined ? __compact : false;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(Pagination$Controls, {
              total: props.total,
              currentPage: currentPage,
              siblingCount: siblingCount,
              compact: compact,
              className: className,
              handlePageChange: props.handlePageChange
            });
}

function rangeEnd(currentPage, perPage, totalRecords) {
  var end_ = Math.imul(currentPage, perPage);
  if (end_ > totalRecords) {
    return totalRecords;
  } else {
    return end_;
  }
}

function Pagination$Bar(props) {
  var __className = props.className;
  var __itemLabel = props.itemLabel;
  var perPage = props.perPage;
  var totalRecords = props.totalRecords;
  var totalPages = props.totalPages;
  var itemLabel = __itemLabel !== undefined ? __itemLabel : "items";
  var className = __className !== undefined ? __className : "";
  var safeTotalPages = totalPages <= 0 ? 1 : totalPages;
  var safeCurrent = clampPage(props.currentPage, safeTotalPages);
  var fromRecord = totalRecords <= 0 ? 0 : Math.imul(safeCurrent - 1 | 0, perPage) + 1 | 0;
  var toRecord = rangeEnd(safeCurrent, perPage, totalRecords);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: totalRecords <= 0 ? JsxRuntime.jsx("p", {
                              children: "No " + itemLabel + " to display",
                              className: "text-sm text-aurometalsaurus"
                            }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: "Showing " + String(fromRecord) + "-" + String(toRecord) + " of " + String(totalRecords) + " " + itemLabel,
                                      className: "text-sm font-medium text-darkcharcoal"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "Page " + String(safeCurrent) + " of " + String(safeTotalPages),
                                      className: "text-xs text-aurometalsaurus mt-0.5"
                                    })
                              ]
                            }),
                      className: "min-w-0"
                    }),
                JsxRuntime.jsx(Pagination$Controls, {
                      total: safeTotalPages,
                      currentPage: safeCurrent,
                      className: "flex-shrink-0 self-end sm:self-auto",
                      handlePageChange: props.handlePageChange
                    })
              ],
              className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-4 py-3 bg-white rounded-xl border border-gray-200 shadow-sm " + className
            });
}

var Bar = {
  rangeEnd: rangeEnd,
  make: Pagination$Bar
};

var make = Pagination;

exports.clampPage = clampPage;
exports.navButtonClass = navButtonClass;
exports.pageButtonClass = pageButtonClass;
exports.activePageButtonClass = activePageButtonClass;
exports.compactShellClass = compactShellClass;
exports.Controls = Controls;
exports.make = make;
exports.Bar = Bar;
/* react/jsx-runtime Not a pure module */
